import styled from 'styled-components'

export const HeaderPortalContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  overflow: hidden;
`
